import { useState, useEffect, useCallback } from "react"

import { Card } from "@material-ui/core"
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip'
import Zoom from '@material-ui/core/Zoom'
import RelatorioService from '@services/RelatorioService'
import {  CardContent } from "@material-ui/core"
import Table from '@base/Table'
import IconButton from '@material-ui/core/IconButton'
import CachedIcon from '@material-ui/icons/Cached'

export const QuantitativoTratamentoNome = (props) => {
	const processo  = props.processo;

	const [quantitativos, setQuantitativos] = useState([]);
	const [loading, setLoading] = useState(true);
	const [refresh, setRefresh] = useState(props.refresh);

	const columns = [
		{
			label: 'ID',
			name: 'id',
			func : (c,l) => c.id,
			hidden: true,
			key: true
		},
		{
			label: 'Tipo',
			name: 'tipo',
			func : (c,l) => c.descricao,
			key: false
		},
		{
			label: 'Pendentes',
			name: 'pendente',
			func: (c,l) => <Link style={{cursor:"pointer", fontWeight: "bold"}} onClick={() => props.aoClicarEmQuantitativo(l.tipo.id,'PENDENTE')}>{c}</Link>,
			key: false
		},
	];

	const carregarDados = useCallback(() => {
		if(processo) {
			setLoading(true);

			RelatorioService.quantitativoTratamentoNome(processo).then(resposta => {
				setQuantitativos(resposta.data);
				setLoading(false);
			});
		}
	}, [processo]);

	useEffect(() => carregarDados(), [carregarDados, refresh]);

	return (
		<Card style={{marginTop:15}}>
			<CardContent style={{ padding:10, fontSize: 14, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>
				Quantitativos
				<Tooltip title={"Atualizar"} TransitionComponent={Zoom}>
					<IconButton size="small" component="div" color={"default"} onClick={() => setRefresh(new Date())} >
						<CachedIcon />
					</IconButton>
				</Tooltip>
			</CardContent>
			<CardContent>
				<Table style={{marginTop:0}}
					columns={columns}
					tableData={quantitativos}
					loading={loading}
					actions={[]}
					page={null}
					rowsPerPage={null}
				/>
			</CardContent>
		</Card>
	);
}

export default QuantitativoTratamentoNome;
